module.exports = {
  findAllTools:'/home/findAllTools',//查询所有工具类
  findToolBySort:'/home/findToolBySort',//根据工具名称查找工具
  findAllExam:'/exam/findAllExam',//查询体检列表中的所有关键字（危害因素或作业）
  findKeywords:'/exam/findKeywords',//搜索模糊查询关键字
  findListsByKeyword:'/exam/findListsByKeyword',//根据关键字查询列表
  findListsByKeywordWithWarnSign:'/exam/findListsByKeywordWithWarnSign',//根据关键字查询列表并获得警示标识

  //化学危害因素职业接触限值
  findAllTouchLimit:'/touchLimit/findAllTouchLimit',//查询所有危害因素职业接触限值
  findInitialList:'/touchLimit/findInitialList',//获取所有化学危害因素接触限值的所有首字母集合
  findTouchLimitsByNames:'/touchLimit/findTouchLimitsByNames',//根据id集合查询

  //粉尘危害因素职业接触限值
  findDustTouchLimit:'/touchLimit/findDustTouchLimit',//查询
  findDustTouchLimitInitials:'/touchLimit/findDustTouchLimitInitials',//首字母

  //生物因素职业接触限值
  findBiologicalTouchLimit:'/touchLimit/findBiologicalTouchLimit',//查询
  getBiologicalTouchLimitInitial:'/touchLimit/getBiologicalTouchLimitInitial',//首字母

  //物理因素职业接触限值
  findUltraHighRadiationTouch:'/touchLimit/findUltraHighRadiationTouch',//超高频辐射
  findHighFrequencyElectromagnetic:'/touchLimit/findHighFrequencyElectromagnetic',//高频电磁场
  findPowerFrequencyElectric:'/touchLimit/findPowerFrequencyElectric',//工频电场
  findLaser:'/touchLimit/findLaser',//激光照射
  findMicrowave:'/touchLimit/findMicrowave',//微波
  findUltravioletRadiation:'/touchLimit/findUltravioletRadiation',//紫外辐射
  findLabourIntensitys:'/touchLimit/findLabourIntensitys',//体力劳动强度
  finfNoise:'/touchLimit/finfNoise',//噪声
  findImpulseNoise:'/touchLimit/findImpulseNoise',//买重噪声
  findHandBorneVibration:'/touchLimit/findHandBorneVibration',//手传震动
  findExcavation:'/touchLimit/findExcavation',//井下挖掘
  findLaborIntensityLevel:'/touchLimit/findLaborIntensityLevel',//体力劳动分级表

  //扫描图片转excel
  scaneImgToExcel:'/scaneImgToExcel/scane',



  // 职业病危害风险分类
  findIndustryCategory:'/riskLevel/findIndustryCategory',//查询行业分类以及危害风险等级

  //获取列表
  getRegulationsList:'/regulations/list',
  findOneRegulationsList:'/regulations/findOne'
}



// WEBPACK FOOTER //
// ./src/serviceAPI.js